import { type ReactElement } from 'react';
import clsx from 'clsx';
import { TdsIcon } from '@scania/tegel-react';
import styles from './style.module.scss';

export type VehicleDetailView = 'avgCycledEnergy' | 'batteryLifeForecast' | 'avgChargePower';

interface ChartContentSwitcherProperties {
  readonly selectedView: VehicleDetailView;
  readonly onViewChange: (view: VehicleDetailView) => void;
  readonly className?: string;
}

const VIEW_OPTIONS: readonly {
  readonly view: VehicleDetailView;
  readonly label: string;
  readonly icon: React.ComponentProps<typeof TdsIcon>['name'];
}[] = [
  { view: 'avgCycledEnergy', label: 'Avg. Cycled Energy / km', icon: 'flash' },
  { view: 'batteryLifeForecast', label: 'Batt. Life forecast', icon: 'calendar' },
  { view: 'avgChargePower', label: 'Charge power', icon: 'powerplug' },
] as const;

const ChartContentSwitcher = ({
  selectedView,
  onViewChange,
  className,
}: ChartContentSwitcherProperties): ReactElement => {
  return (
    <div className={clsx(styles.container, className)} role="tablist" aria-label="Vehicle detail chart views">
      {VIEW_OPTIONS.map(({ view, label, icon }) => {
        const isSelected = view === selectedView;

        return (
          <button
            key={view}
            type="button"
            role="tab"
            aria-selected={isSelected}
            className={clsx(styles.item, { [styles.selected]: isSelected })}
            onClick={() => onViewChange(view)}
          >
            <TdsIcon name={icon} size="16px" />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ChartContentSwitcher;
